import { render, staticRenderFns } from "./SupplierContactDetails.vue?vue&type=template&id=4594b28f&scoped=true&"
import script from "./SupplierContactDetails.vue?vue&type=script&lang=js&"
export * from "./SupplierContactDetails.vue?vue&type=script&lang=js&"
import style0 from "./SupplierContactDetails.vue?vue&type=style&index=0&id=4594b28f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4594b28f",
  null
  
)

export default component.exports